import { useParams } from "react-router-dom";
import { Grid2 as Grid, IconButton, Stack, Typography } from "@mui/material";
import { Trash2 } from "lucide-react";
import Price from "./Price";
import { useAppDispatch } from "@/hooks";
import { removeItemFromOrder } from "@/features/order/slice";
import { getOrderItemPrice, getOrderDetails } from "@/utils/order";
import { OrderItem as OrderItemType } from "@/types";
import { useContext } from "react";
import { WebsiteContext } from "@/pages/website/WebsiteProvider";

interface Props extends OrderItemType {
  canEdit?: boolean;
  settings: any[];
  comments?: string;
}

const OrderItem = (dish: Props) => {
  const { id, title, quantity, canEdit } = dish;
  const dispatch = useAppDispatch();
  const { organization } = useContext(WebsiteContext);
  const { organizationId } = useParams();

  const orgId = organizationId ?? organization?.id;

  return (
    <Grid container sx={{ alignItems: "center" }}>
      <Grid size={{ xs: 1 }}>
        <Typography variant="h4" fontSize={"18px"}>
          {quantity}
        </Typography>
      </Grid>
      <Grid size={{ xs: 11 }}>
        <Stack direction="row" alignItems="center" spacing={2} justifyContent={"space-between"}>
          <Stack>
            <Typography variant="h4" fontSize={"18px"}>
              {title}
            </Typography>
            <Typography variant="caption" fontSize={"14px"} color="textSecondary">
              {getOrderDetails(dish as OrderItemType)}
            </Typography>
          </Stack>

          <Stack spacing={1} direction="row" alignItems="center" justifyContent={"space-between"}>
            <Typography variant="h4" fontSize={"18px"}>
              <Price currency="NIO">{getOrderItemPrice(dish as OrderItemType)}</Price>
            </Typography>

            {canEdit ? (
              <IconButton edge="end" size="medium" aria-label="delete" onClick={() => dispatch(removeItemFromOrder({ organizationId: orgId, itemId: id }))}>
                <Trash2 />
              </IconButton>
            ) : null}
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default OrderItem;
